import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../store/reducers';
import { TestTakerActions, AppUiActions } from '../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import * as Enum from '../../../dtos/enums';
import { TestContentService } from '../../../services/test-content.service';
import { TestTakerService } from '../../../services/test-taker.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'start-screen-start-code',
    template: require('./start-screen-start-code.component.html')
})
export class StartScreenStartCodeComponent implements OnDestroy, OnInit {
    stationNumber: number;
    testTakerPhotoUrl: string;
    errorMsg: string;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment = {} as any;
    private routeParamsSubscription: Subscription;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private store: Store<fromRoot.State>,
        private myModal: MyModal
    ) {
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (params) {
                const stationNumber = params['station-number'];
                if (!this.testTakerService.testTakerInfo) {
                    this.router.navigate([`start-screen/${stationNumber}/pending`]);
                } else {
                    this.stationNumber = stationNumber;
                    this.testTakerInfo = this.testTakerService.testTakerInfo;
                    this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(this.testTakerInfo.BrandName, this.testTakerInfo.TestSessionSiteCode, this.testTakerInfo.TestTakerId);
                }
            }
        });
    }

    ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
    }

    clearErrorMsg() {
        this.errorMsg = "";
    }

    verifyStartCodeAndBeginTest(startCode: string) {
        if (startCode != this.testTakerInfo.StartCode) {
            this.errorMsg = "Invalid Start Code.";
            this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.StartCodeWrongInput);
        } else {
            this.testTakerService.startTest().subscribe(
                success => {
                    this.store.dispatch(new TestTakerActions.SetTestInitializationInfo(success));
                    this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.StartCodeCorrectInput);
                    this.router.navigate([`assessment-test/${this.testTakerInfo.AssessmentTestId}`]);
                },
                error => {
                    this.myModal.showRegularDlg("Error", error);
                }
            );
        }
    }

    txtStartCodeKeyDown(event: KeyboardEvent, startCode: string) {
        this.clearErrorMsg();
        if (event.keyCode == 13) {
            this.verifyStartCodeAndBeginTest(startCode);
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-start-code.component.ts